import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";
/**
 * @deprecated - [fabric-deprecated] - Use MissingPasswordService from app-account mfe instead
 */
@Injectable({
	providedIn: "root",
})
export class PersonalDataConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}
	/**
	 * @deprecated - [fabric-deprecated] - Use MissingPasswordService from app-account mfe instead
	 */
	getEndpoint(): string {
		return this.configService.get(
			(x) => x.common.personalData.endpoints!.personalData,
			"v1/subject-access-requests"
		);
	}
}
